import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

export type Language = 'ru' | 'en'

const copy = {
  ru: {
    workspace: 'Разделы',
    newResearch: 'Подобрать стек',
    stacks: 'Стеки',
    library: 'Библиотека',
    pairs: 'Проверка пар',
    evidence: 'Исследования',
    builder: 'Мой стек',
    databaseReady: 'База знаний доступна',
    menuOpen: 'Открыть меню',
    menuClose: 'Закрыть меню',
    goalEyebrow: 'Персональный подбор',
    goalTitle: 'Какое состояние вы хотите улучшить?',
    goalIntro: 'Опишите цель и отметьте желаемые эффекты. BIOHACK AI подберёт подходящие варианты и проверит взаимодействия между всеми компонентами.',
    goal: 'Опишите цель',
    goalHelp: 'Укажите важный контекст: время суток, ограничения и вещества, которые вы уже принимаете.',
    goalPlaceholder: 'Например: устойчивое внимание в первой половине дня без усиления тревожности',
    desired: 'Желаемые эффекты',
    desiredHelp: 'Отметьте то, что для вас важнее всего.',
    minimize: 'Чего хотите избежать',
    minimizeHelp: 'Отметьте нежелательные эффекты.',
    current: 'Что вы уже принимаете',
    exclude: 'Что исключить',
    researchMode: 'Какие вещества учитывать',
    excludeResearch: 'Только основные',
    includeResearch: 'Добавить исследовательские',
    stackSize: 'Размер стека',
    requestSummary: 'Ваш выбор',
    run: 'Подобрать стек',
    running: 'Подбираем варианты…',
    noMedical: 'BIOHACK AI не заменяет консультацию врача. Если взаимодействие не найдено, это не значит, что сочетание безопасно.',
    search: 'Поиск',
    add: 'Добавить',
    remove: 'Удалить',
    retry: 'Повторить',
    loading: 'Загружаем данные…',
    apiError: 'Не удалось загрузить данные',
    apiErrorHelp: 'Сервис временно не отвечает. Попробуйте ещё раз.',
    selected: 'выбрано',
    results: 'Варианты под вашу цель',
    graphProvider: 'Подобрано под вашу цель',
    requestComplete: 'Проверка завершена',
    profiles: 'веществ в базе',
    effectAssertions: 'описанных эффектов',
    mechanisms: 'описанных механизмов',
    interactionHypotheses: 'взаимодействий в базе',
    stackOptions: 'Варианты стеков',
    notEfficacyRanking: 'Сравните состав, взаимодействия и ограничения каждого варианта.',
    components: 'Компоненты',
    checkedPairs: 'Проверено пар',
    positive: 'Полезные связи',
    negative: 'Риски и ограничения',
    unknown: 'Нет данных',
    unknownPairs: 'Пары без данных',
    calculatedScore: 'Итоговая оценка',
    evidenceScore: 'Уровень данных',
    uncertaintyScore: 'Неопределённость',
    proposed: 'Вариант',
    researchOnly: 'Исследовательская запись',
    openAudit: 'Подробнее',
    baselineStacks: 'Готовые стеки',
    generatedStacks: 'Подобрано для вас',
    filters: 'Фильтры',
    audit: 'Проверка стека',
    back: 'Назад',
    overview: 'Обзор',
    pathways: 'Эффекты',
    interactions: 'Взаимодействия',
    sourceData: 'Данные и источники',
    studyRegimens: 'Режимы приёма из источников',
    role: 'Роль',
    rationale: 'Обоснование',
    targetEffects: 'Целевые эффекты',
    targetMechanisms: 'Связанные механизмы',
    systemRisks: 'Общие риски',
    noSystemRisks: 'Отдельные общие риски для этого стека не указаны.',
    everyPairVisible: 'Проверены все возможные пары. Если данных о сочетании нет, это указано отдельно.',
    noCombinationStudy: 'Исследований этого сочетания не найдено',
    pairHypothesisMissing: 'В базе нет данных об этой паре. Это не означает, что сочетание безопасно или совместимо.',
    graphEmpty: 'Для этого набора данных схема недоступна.',
    resetGraph: 'Показать весь граф',
    fullscreen: 'Развернуть схему',
    closeFullscreen: 'Закрыть полноэкранный режим',
    selectedNode: 'Выберите элемент схемы',
    incoming: 'Входящие связи',
    outgoing: 'Исходящие связи',
    confidence: 'Оценка уверенности',
    status: 'Статус',
    type: 'Тип',
    libraryTitle: 'Библиотека веществ',
    libraryIntro: 'Сравнивайте вещества, их эффекты, механизмы действия, риски и доступные данные.',
    substances: 'веществ',
    class: 'Класс',
    effects: 'Эффекты',
    pk: 'Фармакокинетика',
    doseContext: 'Данные о дозировке',
    links: 'Взаимодействия',
    allClasses: 'Все классы',
    researchFilter: 'Категория',
    all: 'Все',
    onlyRegular: 'Основные',
    onlyResearch: 'Исследовательские',
    prev: 'Назад',
    next: 'Далее',
    page: 'Страница',
    noMatches: 'Ничего не найдено. Измените запрос или фильтры.',
    profile: 'Профиль вещества',
    aliases: 'Другие названия',
    forms: 'Формы и варианты',
    claimedEffects: 'Описанные эффекты',
    useful: 'Положительные',
    contextual: 'Зависят от контекста',
    adverse: 'Нежелательные',
    mechanismMap: 'Механизмы',
    pharmacokinetics: 'Фармакокинетика и метаболизм',
    risks: 'Риски и ограничения',
    sourceRegimen: 'Схемы приёма из источников',
    sources: 'Источники',
    nullResults: 'Исследования, где эффект не подтвердился',
    contradictions: 'Противоречивые данные',
    findIherb: 'Искать на iHerb',
    iherbNotice: 'BIOHACK AI не проверяет состав и качество товаров, найденных на iHerb.',
    comparePair: 'Проверить взаимодействие',
    pairTitle: 'Проверка взаимодействий',
    pairIntro: 'Выберите два вещества. Мы покажем известные взаимодействия, возможные эффекты и ограничения.',
    substanceA: 'Вещество A',
    substanceB: 'Вещество B',
    chooseSubstance: 'Выберите вещество',
    chooseDifferentSubstances: 'Выберите два разных вещества.',
    pairResult: 'Результат проверки',
    possibleBenefit: 'Возможный эффект',
    limitation: 'Риски и ограничения',
    inferenceSteps: 'Почему сделан такой вывод',
    combinationEvidence: 'Данные о сочетании',
    addToStack: 'Добавить оба вещества',
    addStackToBuilder: 'Добавить весь стек',
    stackBuilderTitle: 'Конструктор стека',
    stackBuilderIntro: 'Добавьте от 2 до 8 веществ. Мы проверим все пары внутри стека.',
    builderEmptyTitle: 'Добавьте первое вещество',
    builderEmptyBody: 'Найдите вещество выше. После добавления двух компонентов станет доступна проверка взаимодействий.',
    auditStack: 'Проверить стек',
    incompleteAudit: 'Для некоторых пар в базе нет данных.',
    clear: 'Очистить',
    evidenceTitle: 'Исследования и источники',
    evidenceIntro: 'Здесь собраны источники о веществах, их эффектах и взаимодействиях.',
    direct: 'Прямые данные',
    supporting: 'Косвенные данные',
    evidenceUnknown: 'Не классифицировано',
    assertion: 'Что показывает источник',
    entity: 'Вещество',
    study: 'Исследование',
    population: 'Группа',
    provenance: 'Основание вывода',
    provenanceHelp: 'Посмотрите источники и шаги рассуждения, на которых основана эта запись.',
    noEvidence: 'По этим условиям ничего не найдено.',
    databaseUnavailable: 'База знаний BIOHACK AI недоступна',
    databaseUnavailableHelp: 'Сервис временно не может получить данные. Попробуйте ещё раз.',
    stackNotFound: 'Стек не найден.',
    runNotFound: 'Результат подбора недоступен. Запустите новый подбор.',
    sourceText: 'Текст источника',
    canonicalName: 'Международное название',
    desiredCount: 'Желаемые эффекты',
    minimizedCount: 'Нежелательные эффекты',
    variantsFound: 'Найдено вариантов',
    pairsReviewed: 'Проверено пар',
    componentLimit: 'Максимум компонентов',
    knowledgeBase: 'База знаний',
    notFoundTitle: 'Страница не найдена',
    notFoundBody: 'Проверьте адрес или вернитесь к подбору стека.',
  },
  en: {
    workspace: 'Sections', newResearch: 'Build a stack', stacks: 'Stacks', library: 'Library', pairs: 'Pair check', evidence: 'Research', builder: 'My stack', databaseReady: 'Knowledge base available', menuOpen: 'Open menu', menuClose: 'Close menu',
    goalEyebrow: 'Personal selection', goalTitle: 'What would you like to improve?', goalIntro: 'Describe your goal and select the outcomes that matter. BIOHACK AI will find suitable options and check every interaction inside each stack.', goal: 'Describe your goal', goalHelp: 'Include useful context: time of day, constraints, and anything you already take.', goalPlaceholder: 'For example: sustained attention in the first half of the day without increased anxiety', desired: 'Desired effects', desiredHelp: 'Select what matters most to you.', minimize: 'What to avoid', minimizeHelp: 'Select the effects you do not want.', current: 'What you already take', exclude: 'What to exclude', researchMode: 'Substances to include', excludeResearch: 'Regular entries only', includeResearch: 'Include research entries', stackSize: 'Stack size', requestSummary: 'Your selection', run: 'Build my stack', running: 'Finding suitable options…', noMedical: 'BIOHACK AI is not a substitute for medical advice. If no interaction is listed, that does not mean the combination is safe.', search: 'Search', add: 'Add', remove: 'Remove', retry: 'Try again', loading: 'Loading data…', apiError: 'Could not load the data', apiErrorHelp: 'The service is not responding. Try again.', selected: 'selected',
    results: 'Options for your goal', graphProvider: 'Selected for your goal', requestComplete: 'Check complete', profiles: 'substances in the library', effectAssertions: 'documented effects', mechanisms: 'documented mechanisms', interactionHypotheses: 'interactions in the library', stackOptions: 'Stack options', notEfficacyRanking: 'Compare the ingredients, interactions, and limitations of each option.', components: 'Components', checkedPairs: 'Pairs checked', positive: 'Helpful interactions', negative: 'Risks and limitations', unknown: 'No data', unknownPairs: 'Pairs without data', calculatedScore: 'Overall score', evidenceScore: 'Evidence level', uncertaintyScore: 'Uncertainty', proposed: 'Option', researchOnly: 'Research entry', openAudit: 'View details', baselineStacks: 'Ready-made stacks', generatedStacks: 'Selected for you', filters: 'Filters',
    audit: 'Stack check', back: 'Back', overview: 'Overview', pathways: 'Effects', interactions: 'Interactions', sourceData: 'Data and sources', studyRegimens: 'Reported regimens', role: 'Role', rationale: 'Why it is included', targetEffects: 'Target effects', targetMechanisms: 'Related mechanisms', systemRisks: 'Overall risks', noSystemRisks: 'No separate overall risks are listed for this stack.', everyPairVisible: 'Every possible pair is checked. If no interaction data exists, it is shown separately.', noCombinationStudy: 'No combination study was found', pairHypothesisMissing: 'There is no interaction data for this pair. This does not mean the combination is safe or compatible.', graphEmpty: 'No diagram is available for this data.', resetGraph: 'Show full diagram', fullscreen: 'Open fullscreen', closeFullscreen: 'Close fullscreen', selectedNode: 'Select an item in the diagram', incoming: 'What affects it', outgoing: 'What it affects', confidence: 'Confidence score', status: 'Status', type: 'Type',
    libraryTitle: 'Substance library', libraryIntro: 'Compare substances, effects, mechanisms, risks, and the evidence available for each profile.', substances: 'substances', class: 'Class', effects: 'Effects', pk: 'Pharmacokinetics', doseContext: 'Dose information', links: 'Interactions', allClasses: 'All classes', researchFilter: 'Category', all: 'All', onlyRegular: 'Regular entries', onlyResearch: 'Research entries', prev: 'Previous', next: 'Next', page: 'Page', noMatches: 'Nothing matched. Try changing the query or filters.',
    profile: 'Substance profile', aliases: 'Other names', forms: 'Forms and variants', claimedEffects: 'Reported effects', useful: 'Positive', contextual: 'Context-dependent', adverse: 'Adverse', mechanismMap: 'Mechanisms', pharmacokinetics: 'Pharmacokinetics and metabolism', risks: 'Risks and limitations', sourceRegimen: 'Regimens reported in sources', sources: 'Sources', nullResults: 'Studies where the effect was not confirmed', contradictions: 'Conflicting evidence', findIherb: 'Search iHerb', iherbNotice: 'BIOHACK AI does not verify the contents or quality of products in iHerb search results.', comparePair: 'Check interaction',
    pairTitle: 'Interaction check', pairIntro: 'Choose two substances to see known interactions, possible effects, and limitations.', substanceA: 'Substance A', substanceB: 'Substance B', chooseSubstance: 'Choose a substance', chooseDifferentSubstances: 'Choose two different substances.', pairResult: 'Check result', possibleBenefit: 'Possible effect', limitation: 'Risks and limitations', inferenceSteps: 'Why this conclusion was reached', combinationEvidence: 'Evidence for the combination', addToStack: 'Add both substances', addStackToBuilder: 'Add the full stack',
    stackBuilderTitle: 'Stack builder', stackBuilderIntro: 'Add 2 to 8 substances. We will check every pair in the stack.', builderEmptyTitle: 'Add your first substance', builderEmptyBody: 'Find a substance above. Interaction checking becomes available after you add two components.', auditStack: 'Check the stack', incompleteAudit: 'There is no interaction data for some pairs.', clear: 'Clear',
    evidenceTitle: 'Research and sources', evidenceIntro: 'Browse sources on substances, their effects, and interactions.', direct: 'Direct evidence', supporting: 'Supporting evidence', evidenceUnknown: 'Not classified', assertion: 'What the source shows', entity: 'Substance', study: 'Study', population: 'Group', provenance: 'Basis for the conclusion', provenanceHelp: 'Review the sources and reasoning steps behind this entry.', noEvidence: 'No records match these filters.', databaseUnavailable: 'The BIOHACK AI knowledge base is unavailable', databaseUnavailableHelp: 'The service cannot retrieve the data right now. Please try again.', stackNotFound: 'Stack not found.', runNotFound: 'This result is unavailable. Start a new selection.',
    sourceText: 'Source text', canonicalName: 'International name', desiredCount: 'Desired effects', minimizedCount: 'Effects to avoid', variantsFound: 'Options found', pairsReviewed: 'Pairs checked', componentLimit: 'Maximum components', knowledgeBase: 'Knowledge base', notFoundTitle: 'Page not found', notFoundBody: 'Check the address or return to the stack builder.',
  },
} as const

type CopyKey = keyof typeof copy.ru
type LanguageContextValue = { language: Language; setLanguage: (language: Language) => void; tr: (key: CopyKey) => string; t: (key: string) => string }
const LanguageContext = createContext<LanguageContextValue | null>(null)

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => localStorage.getItem('biograph-language') === 'en' ? 'en' : 'ru')
  const value = useMemo<LanguageContextValue>(() => ({
    language,
    setLanguage: (next) => { localStorage.setItem('biograph-language', next); setLanguageState(next) },
    tr: (key) => copy[language][key] || copy.en[key],
    t: (key) => (copy[language] as Record<string, string>)[key] || key,
  }), [language])
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
}

export function useLanguage() {
  const context = useContext(LanguageContext)
  if (!context) throw new Error('useLanguage must be used within LanguageProvider')
  return context
}

function localizeData<T>(value: T, language: Language): T {
  if (Array.isArray(value)) return value.map((item) => localizeData(item, language)) as T
  if (!value || typeof value !== 'object') return value

  const source = value as Record<string, unknown>
  const result = Object.fromEntries(Object.entries(source).map(([key, item]) => [key, localizeData(item, language)]))
  const fields = [
    ['name', 'nameRu', 'nameEn'],
    ['nameA', 'nameARu', 'nameAEn'],
    ['nameB', 'nameBRu', 'nameBEn'],
    ['label', 'labelRu', 'labelEn'],
    ['rationale', 'rationaleRu', 'rationaleEn'],
    ['entityName', 'entityNameRu', 'entityNameEn'],
    ['systemLabel', 'systemLabelRu', 'systemLabelEn'],
  ] as const

  for (const [target, ru, en] of fields) {
    const localized = language === 'ru' ? source[ru] : source[en]
    if (typeof localized === 'string' && localized.trim()) result[target] = localized
  }

  const arrayFields = [
    ['desiredEffects', 'desiredEffectsRu', 'desiredEffectsEn'],
    ['coveredEffects', 'coveredEffectsRu', 'coveredEffectsEn'],
  ] as const

  for (const [target, ru, en] of arrayFields) {
    const localized = language === 'ru' ? source[ru] : source[en]
    if (Array.isArray(localized) && localized.length) result[target] = localized
  }

  return result as T
}

export function useLocalizedData<T>(value: T): T {
  const { language } = useLanguage()
  return useMemo(() => localizeData(value, language), [language, value])
}
